import _ from 'lodash'
import calendars from 'scoreboard/components/calendars'
const { DAILY, WEEKLY, MONTHLY, YEARLY, FISCAL_YEARLY } = calendars
import unwrapModel from 'scoreboard/components/unwrap-model'
import SummaryType from 'scoreboard/datasets/model/summary-type'
const { MONTH_OF_THE_YEAR, DAY_OF_THE_WEEK } = SummaryType

/**
 * Returns whether a query that should be treated as "Month of the Year".
 * Should mirror the implementation of DatasetsQueryUtil#isMonthOfTheYear
 *
 * @params {Object|DatasetTable} options
 * @param {String} [options.summaryType]
 * @param {Number|String} options.groupCalendarId
 * @param {Number|String} options.breakdownCalendarId
 */
function isMonthOfTheYear(options = {}) {
	options = unwrapModel(options)
	if (options.summaryType === MONTH_OF_THE_YEAR) {
		return true
	}

	let compareAllTimeOptions = _.defaults({
		breakdownCalendarType: MONTHLY,
		groupCalendarTypes: [YEARLY, FISCAL_YEARLY]
	}, options)
	return isCompareAllTime(compareAllTimeOptions)
}

/**
 * Returns whether a query that should be treated as "Day of the Week".
 * Should mirror the implementation of DatasetsQueryUtil#isDayOfTheWeek
 *
 * @params {Object|DatasetTable} options
 * @param {String} [options.summaryType]
 * @param {Number|String} options.groupCalendarId
 * @param {Number|String} options.breakdownCalendarId
 */
function isDayOfTheWeek(options = {}) {
	options = unwrapModel(options)
	if (options.summaryType === DAY_OF_THE_WEEK) {
		return true
	}

	let compareAllTimeOptions = _.defaults({
		breakdownCalendarType: DAILY,
		groupCalendarTypes: [WEEKLY]
	}, options)
	return isCompareAllTime(compareAllTimeOptions)
}

/**
 * Indicates whether this is a special case for "Compare Time Periods"
 * breakdowns that considers all time rather than being restricted to just
 * the calendars defined in admin. Should mirror the implementation of
 * DatasetsQueryUtil#isCompareAllTime
 * @param {Number|String} groupCalendarId
 * @param {Number|String} breakdownCalendarId
 * @param {String} breakdownCalendarType the type of the breakdown calendar
 * @param {String[]} groupCalendarTypes the types of the group calendars
 * @returns {boolean}
 */
function isCompareAllTime({ groupCalendarId, breakdownCalendarId,
		breakdownCalendarType, groupCalendarTypes }) {
	if (!groupCalendarId || !breakdownCalendarId) return false
	let groupCalendar = calendars.calendarsById[groupCalendarId]
	let matchingGroupCalendar =
		_.includes(groupCalendarTypes, _.get(groupCalendar, 'type')) ||
		_.includes(groupCalendarTypes, "" + groupCalendarId)
	let matchingBreakdownCalendar = isCalendarOfType(breakdownCalendarId,
		breakdownCalendarType)
	return matchingGroupCalendar && matchingBreakdownCalendar
}

/**
 * Returns whether the given calendar is of the given type.
 * @param {Object|Number} calendar an object representing the calendar, or a
 * calendarId
 * @param {String} type the potential type of the calendar
 * @return {boolean}
 */
function isCalendarOfType(calendar, type) {
	let calendarId = _.get(calendar, 'id', calendar)
	calendar = calendars.calendarsById[calendarId]
	return type === _.get(calendar, 'type') ||
		type === "" + calendarId
}

export { isMonthOfTheYear, isDayOfTheWeek, isCalendarOfType }
